module.exports = __webpack_public_path__ + "6dea5c7aa2cd82176902737915773293.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/list/subImg/jdjs-bg.jpg
// module id = 141
// module chunks = 0